import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetLifeplaceProducts,
	GetLifeplaceProductsModel,
	GetLifeplaceProductsParams,
} from 'domain/usecases/private/lifeplace/get-lifeplace-products';

export class RemoteGetLifeplaceProducts implements GetLifeplaceProducts {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetLifeplaceProductsModel>,
	) {}

	async get(params: GetLifeplaceProductsParams): Promise<GetLifeplaceProductsModel> {
		const {signal, ...otherParams} = params;

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: otherParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
